export const REQUIRED_ATTRIBUTE_MESSAGE = 'Recommended for rate calculation accuracy.';
export const INVALID_DATE_ERROR = 'Invalid date.';
export const DATE_OUT_OF_RANGE_ERROR = 'The date must be within 30 days.';
export const DATE_OVER_THE_MAX_DATE_ERROR = 'The date must not be in the future.';
